export default "__VITE_ASSET__c0419a35__"